<div class="gridItemChildModule w-100 h-100 d-flex flex-column">
    <!-- Search -->
    <div class="search-box live-search w-75 mx-auto my-2" 
        [hidden]="!showFilter"
        >
        <input type="search" 
            class="form-control" 
            autocomplete="off" 
            [(ngModel)]="filterValue" 
            (ngModelChangeDebounced)="applyFilter()"
            [ngModelChangeDebounceTime]="400"            
            cvLocalizedPlaceholder 
            [langSection]="'Common'" 
            [langKey]="'Search'" 
        />
        <span 
            class="clear-input" 
            role="button" 
            tabindex="0" 
            [hidden]="filterValue?.length < 1" 
            (click)="clearFilter()"
        >
        </span>
    </div>
    <!-- Content -->
    <ag-grid-angular 
        #loginLogoutWidgetGrid
        class="ag-theme-balham flex-fill"
        *ngIf="gridOptions"
        [hidden]="!isDataFirstLoaded"
        [gridOptions]="gridOptions"
    >
    </ag-grid-angular>
</div>

